import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { constants } from '../../constants/constants';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { HealthLifestyle } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { Observable } from 'rxjs';
import { rangeData } from 'src/app/pages/medical-underwriting/model';


@Injectable()
export class HealthService {

   // private contentData: object;
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  constructor(private httpClient: HttpClient) {}

  public getHealthContent(): Observable<HealthLifestyle> {
    
    return this.httpClient.get<HealthLifestyle>(this.endPoints.healthAndLifeStyleURL);
  }
  public getNextStepJson(jsonUrl): Observable<HealthLifestyle> {
    
    let temp = jsonUrl.split("=");
    temp = temp[1] ? temp[1] : "";
    let urlToRefer: string;
    if (CURRENT_ENVIROMENT.environment === 'higherEnvironment'){
          urlToRefer = SERVICE_END_POINT.brmsUrl + temp;
    } else {
          urlToRefer = SERVICE_END_POINT.localBrms + temp;
    }
    return this.httpClient.get<HealthLifestyle>(urlToRefer);
  }

 public getMedicalConditionJson(medicalConditionUrl: string):Observable<HealthLifestyle> {
   let urlToRefer: string;
  if (CURRENT_ENVIROMENT.environment === 'higherEnvironment'){
        urlToRefer = SERVICE_END_POINT.brmsUrl + medicalConditionUrl;
  } else {
        urlToRefer = SERVICE_END_POINT.localBrms + medicalConditionUrl;
  }
    return this.httpClient.get<HealthLifestyle>(urlToRefer);
  }

  public getRangeValidation(): Observable<any> {
    
    return this.httpClient.get<any>(this.endPoints.rangeValidationURL);
  }

  public getInitialQuestionContent(): Observable<HealthLifestyle> {
    
    return this.httpClient.get<HealthLifestyle>(this.endPoints.initialQuestionURL);
  }

  public getMedicineNamesJson(medicationsDataJsonURL): Observable<any> {
    let temp = medicationsDataJsonURL.split("=");
    temp = temp[1] ? temp[1] : "";
   let urlToRefer: string;
  if (CURRENT_ENVIROMENT.environment === 'higherEnvironment'){
        urlToRefer = SERVICE_END_POINT.configBrmsUrl + temp;
  } else {
        urlToRefer = SERVICE_END_POINT.localBrms + temp;
  }
    return this.httpClient.get<any>(urlToRefer); 
  }


}


